import styled from 'styled-components'

import { themeColor } from '../theme'

import { TextProps, Text } from './Text'

const StyledErrorText = styled(Text)<ErrorTextProps>`
  color: ${themeColor('danger')};
  border: ${({ border }) => (border ? `1px solid` : undefined)};
  border-color: ${({ border }) => (border ? themeColor('danger') : undefined)};
  border-radius: ${({ border }) => (border ? '4px' : undefined)};
  font-size: 12px;
  padding: 8px;
`

export type ErrorTextProps = {
  border?: boolean
} & TextProps

export const ErrorText = ({ ...rest }) => {
  return <StyledErrorText block bold {...rest} />
}
